export default "__VITE_ASSET__kuyu9G5d__"